import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RankingEntregaProvider,
  useRankingEntrega,
} from "./context/RankingEntregaContext";
import { RankingEntregaView } from "./components/RankingEntregaView";
import { useAuth } from "../../../context/AuthContext";
import { hasFullAccessUser } from "../../../lib/screenAccess";

const RankingEntregaContent: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdministrador = hasFullAccessUser(user);
  const {
    aguardando,
    emEntrega,
    top3Entregadores,
    lojas,
    isLoading,
    selectedLojaId,
    showLojaSelector,
    dateLabel,
    selectedLojaNome,
    chamadoAtual,
    segundosRestantes,
    toggleLojaSelector,
    selectAllLojas,
    selectLoja,
  } = useRankingEntrega();

  if (isLoading) {
    return (
      <div className="relative flex min-h-screen items-center justify-center overflow-auto bg-gradient-to-br from-primary via-red-900 to-primary text-white">
        <div className="text-center">
          <p className="text-xl">Carregando fila de entregas...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingEntregaView
      aguardando={aguardando}
      emEntrega={emEntrega}
      top3Entregadores={top3Entregadores}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={showLojaSelector}
      showLojaSelectorUI={isAdministrador}
      dateLabel={dateLabel}
      selectedLojaNome={selectedLojaNome}
      chamadoAtual={chamadoAtual}
      segundosRestantes={segundosRestantes}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaSelector}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
    />
  );
};

const RankingEntregaPage: React.FC = () => {
  return (
    <RankingEntregaProvider>
      <RankingEntregaContent />
    </RankingEntregaProvider>
  );
};

export default RankingEntregaPage;
export { RankingEntregaView } from "./components/RankingEntregaView";
export type { RankingEntregaViewProps } from "./types";
